import { Tooltip } from "antd";
import { TooltipPlacement } from "antd/es/tooltip";
import React from "react";
import Select, { components } from "react-select";
import CustomArrowIcon from "../assets/select-arrow.svg";
import CustomTooltipIcon from "../assets/tooltip.svg";

const customStyles = {
  control: (base: any, state: any) => ({
    ...base,
    paddingLeft: "10px",
    borderRadius: "8px",
    border: "2px solid #3F51B5",
    backgroundColor: "#1C2434",
    color: "#FFF",
    "&:hover": {
      borderColor: state.isFocused ? "#3F51B5" : "#3F51B5",
      backgroundColor: "#1C2434",
    },
  }),
  singleValue: (base: any) => ({
    ...base,
    color: "#FFF",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  }),
  dropdownIndicator: (base: any) => ({
    ...base,
    color: "transparent",
    paddingRight: "0.5rem",
    paddingLeft: 0,
    marginLeft: 0,
    display: "flex",
    alignItems: "center",
  }),
  menu: (base: any) => ({
    ...base,
    backgroundColor: "#232D42",
    borderRadius: "8px",
  }),
  option: (base: any, state: any) => ({
    ...base,
    backgroundColor: state.isSelected ? "#3F51B5" : "#232D42",
    color: "#FFF",
    padding: "0.5rem 1rem",
    textAlign: "left",
    "&:hover": {
      backgroundColor: state.isSelected ? "#3F51B5" : "#1C2434",
    },
  }),
  valueContainer: (base: any) => ({
    ...base,
    padding: 0,
  }),
};

interface CustomSelectProps {
  label: string;
  options: { value: string; label: string }[];
  title: React.ReactNode;
  onChange: (selectedOption: any) => void;
  placement?: TooltipPlacement;
}

const CustomSelect: React.FC<CustomSelectProps> = ({
  label,
  options,
  title,
  onChange,
  placement,
}) => {
  const CustomControl = ({ children, ...props }: any) => (
    <components.Control {...props}>
      <div className="cursor-pointer h-10 w-6 items-center justify-center flex"></div>
      {children}
    </components.Control>
  );

  const CustomDropdownIndicator = (props: any) => (
    <components.DropdownIndicator {...props}>
      <img src={CustomArrowIcon} alt="dropdown-indicator" />
    </components.DropdownIndicator>
  );

  return (
    <div className="relative w-full">
      <label className="absolute top-[-10px] left-5 bg-[#1C2434] px-1 text-xs text-white z-10">
        {label}
      </label>
      <Tooltip
        title={title}
        placement={placement || "bottom"}
        trigger={["hover"]}
        className="absolute top-[3px] left-[10px] text-xs text-white z-10"
      >
        <div className="cursor-pointer h-10 w-6 items-center justify-center flex">
          <img
            src={CustomTooltipIcon}
            alt="tooltip"
            style={{ pointerEvents: "none" }}
          />
        </div>
      </Tooltip>
      <Select
        options={options}
        styles={customStyles}
        components={{
          Control: CustomControl,
          DropdownIndicator: CustomDropdownIndicator,
          IndicatorSeparator: () => null,
        }}
        classNamePrefix="react-select"
        defaultValue={options[0]}
        onChange={onChange}
        isSearchable={false}
      />
    </div>
  );
};

export default CustomSelect;
